/* globals document, window */
import React, { Fragment } from "react";
import GlobalAlert from "../common/GlobalAlert";
import SellForm from "./SellForm";
import Testimonials from "../common/Testimonials";

import { GlobalProvider } from "../common/GlobalContext";

type Props = {
  alerts: Array<Object>,
  className: string,
  compliance: Object,
  favorites: Array<number>,
  previousFormFieldValues: Object,
  RECAPTCHA_CLIENT: string,
  RECAPTCHA_CLIENT_V2: string,
  siteUser: Object,
  states: Array<Object>,
  testimonials: Array<Object>,
  theme: Object, // theme from the API/site settings, not the react-jss theme
  cta: string, // Call To Action
};

const Sell = ({
  alerts,
  compliance,
  favorites,
  previousFormFieldValues,
  RECAPTCHA_CLIENT,
  RECAPTCHA_CLIENT_V2,
  siteUser,
  states,
  testimonials,
  theme,
  cta,
}: Props) => {
  return (
    <GlobalProvider
      compliance={compliance}
      favorites={favorites}
      siteUser={siteUser}
      theme={theme}
      RECAPTCHA_CLIENT={RECAPTCHA_CLIENT}
      RECAPTCHA_CLIENT_V2={RECAPTCHA_CLIENT_V2}
    >
      <Fragment>
        <GlobalAlert alerts={alerts} />
        <SellForm
          previousFormFieldValues={previousFormFieldValues}
          states={states}
          cta={cta}
        />
        <Testimonials testimonials={testimonials} />
      </Fragment>
    </GlobalProvider>
  );
};

export default Sell;
